import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CatalogsComponent } from './catalogs.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: CatalogsComponent }
    ])
  ],
  exports: [RouterModule]
})
export class CatalogsRoutingModule { }
